define.alias("ember-composable-helpers/helpers/sort-by", "calendar/helpers/sort-by");